import { CYCLE_RUNS_CRUD_ACTION_CONSTANTS } from '../actions/cycle_runs_actions';
import { standardInitialStateGenerator, standardReducerGenerator } from './standard_reducer_utils';

const initialState: any = standardInitialStateGenerator(['AssetCycleRunsIndex']);

export default standardReducerGenerator(CYCLE_RUNS_CRUD_ACTION_CONSTANTS, initialState);
